import { render, staticRenderFns } from "./WordBase.vue?vue&type=template&id=db71e834&scoped=true&"
import script from "./WordBase.vue?vue&type=script&lang=js&"
export * from "./WordBase.vue?vue&type=script&lang=js&"
import style0 from "./WordBase.vue?vue&type=style&index=0&id=db71e834&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db71e834",
  null
  
)

export default component.exports